<template>
    <li>
        <button
            @click.prevent="removePin(pin.type, pin.pinnable_id, pin.name)"
            :disabled="isLoading"
            class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-white flex gap-3 items-center w-full p-3 rounded hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 hover:dark:border-v2-gray-90 text-v2-red"
        >
            <LoadingCircle v-if="isLoading" class="w-4.5 h-4.5" />
            <BaseSvg v-else name="TrashCan" class="size-[18px]"/>
            <span class="text-xs leading-none">Remove Pin</span>
        </button>
    </li>
</template>

<script setup>
import {BaseSvg, LoadingCircle} from "@/Components";
import {usePinsDrawer} from "@/Composables";

const props = defineProps(['pin']);

const { removePin, isLoading } = usePinsDrawer();
</script>
